<div class="page-content-wrapper">
  <div class="card shadow rounded-3 border-1">
    <div class="card-header bg-white border-0 me-2 d-flex justify-content-between align-items-center">
      <p class="text-s fw-bold">Users</p>
      <button type="button" class="btn  btn-dark btn-sm text-xs fw-bold rounded-3 shadow float-end" data-bs-toggle="modal" data-bs-target="#addUserModal">
        <i class="fas fa-plus"></i> Add Users
      </button>
    </div>
    <div class="card-body">

      <CustomTabs
        :tabs="tabs"
        v-model="currentTab"
      />
      <div class="tab-content">
        <CustomTable
          :columns="columns"
          :fetchData="getUsers"
          :key="currentTab"
          :hasActions="true"
          :tableKey="`client_users_${currentTab}`"
        >
          <template v-slot:cell-name_email="{ row }">
            {{ row.first_name || row.full_name }} {{ row.last_name || '' }}
            <p class="text-xxs fw-bold">{{ row.email }}</p>
          </template>
          <template v-slot:cell-date_joined="{ row }">
            {{ formatDate(row.date_joined) }}
          </template>
          <template v-slot:actions="{ row }">
            <button
              v-if="currentTab === 'ClientAdmins'"
              class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow"
              @click="view_client_admin(row.id)"
            >View</button>
            <button
              v-else-if="currentTab === 'Clients'"
              class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow me-2"
              @click="view_client(row.id)"
            >View</button>
            <button
              v-else-if="currentTab === 'Customers'"
              class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow me-2"
              @click="view_customer_data(row.id)"
            >View</button>
            <button
              v-if="currentTab === 'Clients' || currentTab === 'Customers'"
              :class="row.is_active ? 'btn btn-danger btn-sm text-xxs fw-bold rounded-3 shadow' : 'btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow'"
              @click="toggleUserStatus(row)"
            >
              {{ row.is_active ? 'Deactivate' : 'Activate' }}
            </button>
          </template>
        </CustomTable>
      </div>
    </div>

    <!-- Add User Modal -->
    <div class="modal fade" id="addUserModal" tabindex="-1" aria-labelledby="addUserModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addUserModalLabel"><strong>Add User</strong></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="add_user">
              <div class="row mb-3">
                <div class="col">
                  <label class="form-label fw-bold"><small>First name</small></label>
                  <input v-model="first_name" type="text" class="form-control text-xs" placeholder="First name" name="first_name"
                     @input="validate_name('first_name')" required>
                  <div class="first-name-message d-none">First name is required</div>
                </div>
                <div class="col">
                  <label class="form-label fw-bold"><small>Last name</small></label>
                  <input v-model="last_name" type="text" class="form-control text-xs" placeholder="Last name" name="last_name"
                    @input="validate_name('last_name')" required>
                  <div class="last-name-message d-none">Last name is required</div>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label fw-bold"><small>Email</small></label>
                <input v-model="email" type="email" class="form-control text-xs" name="email" placeholder="Email" 
                  @input="validate_email_input" required>
                <div class="email-message d-none">Email is required</div>
              </div>
              <div class="mb-3">
                <label class="form-label fw-bold"><small>Phone number</small></label>
                <input v-model="phone_number" type="tel" class="form-control text-xs" placeholder="Enter phone number" name="phone_number" maxlength="10"
                  @input="validate_phone_number_input" required>
              </div>
              <div class="mb-3">
                <label class="form-label fw-bold"><small>User Type</small></label>
                <select v-model="role" class="form-select text-xs" required>
                  <option value="" disabled hidden>Select user Type</option>
                  <option value="Client">Client</option>
                </select>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn bg-green btn-sm text-xs fw-bold rounded-small" :disabled="!isFormValid">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
